export const PHONE_TEL = "tel:+18888089551";
export const PHONE_DISPLAY = "(888) 808-9551";
export const EMAIL = "support@reservecheapflights.com";
export const BRAND = "Reserve Cheap Flights";
export const COMPANY = "Escape Low Fare Studio OPC Pvt. Ltd.";
export const INDIA_ADDRESS = ["Block B1, Building-162, Third Floor", "Vasundhara Enclave", "New Delhi, Delhi 110096", "India"];

export const NAV = [
  { to: "/flights", label: "Flights" },
  { to: "/hotels", label: "Hotels" },
  { to: "/deals", label: "Deals" },
  { to: "/cars", label: "Cars" },
  { to: "/cruises", label: "Cruises" },
  { to: "/holiday-packages", label: "Packages" },
  { to: "/blog", label: "Blog" },
];
export const NAV_2 = [
  { to: "/about", label: "About" },
  { to: "/help", label: "Help" },
  { to: "/contact", label: "Contact" },
];

export const AIRLINES = [
  ["BA", "British Airways"], ["EK", "Emirates"], ["QR", "Qatar Airways"], ["LH", "Lufthansa"],
  ["AF", "Air France"], ["KL", "KLM"], ["AC", "Air Canada"], ["VS", "Virgin Atlantic"],
  ["TK", "Turkish Airlines"], ["QF", "Qantas"], ["SQ", "Singapore Airlines"], ["AI", "Air India"],
  ["AA", "American Airlines"], ["DL", "Delta Air Lines"], ["UA", "United Airlines"], ["WN", "Southwest Airlines"],
  ["AS", "Alaska Airlines"], ["B6", "JetBlue"], ["HA", "Hawaiian Airlines"], ["F9", "Frontier Airlines"],
].map(([code, name]) => ({ code, name, slug: `${name.toLowerCase().replace(/\s+/g, "-")}-${code.toLowerCase()}-flight-deals`, logo: `/airlines/${code}.png` }));

export const FOOTER_AIRLINES = AIRLINES.slice(0, 9).filter((a) => a.code !== "AC");

export const DESTINATIONS = [
  { slug: "dubai", name: "Dubai", image: "/img/pk/dubai.jpg", blurb: "Skyline stopovers, desert evenings and easy connections onward to Asia and Africa." },
  { slug: "london", name: "London", image: "/img/london-flight-deals.webp", blurb: "Theatre nights, royal parks and some of the busiest transatlantic routes from the USA." },
  { slug: "paris", name: "Paris", image: "/img/paris-flight-deals.webp", blurb: "Café terraces, museums and nonstop options from major U.S. gateways." },
  { slug: "tokyo", name: "Tokyo", image: "/img/tokyo-flight-deals.webp", blurb: "Neon nights, quiet shrines and long-haul options from the West Coast." },
  { slug: "new-york", name: "New York", image: "/img/new-york.webp", blurb: "The city that never sleeps, with flights from nearly every U.S. airport." },
];

export const MORE_WAYS = [
  { to: "/deals", label: "Worldwide flight deals" },
  { to: "/holiday-packages", label: "Holiday packages" },
  { to: "/hotels", label: "Hotels" },
  { to: "/cruises", label: "Cruises" },
  { to: "/group-travel", label: "Group travel" },
  { to: "/business-travel", label: "Business travel" },
  { to: "/student-travel", label: "Student travel" },
  { to: "/site-map", label: "All destinations & airlines" },
];
